export enum CardDataSource {
  Aggregated = 'aggregated',
  EncounterLevel = 'encounter',
}
